export default __webpack_public_path__ + "static/media/news2.3342d772.png";